/**
 * SF Countdown Banner
 * Self-contained JS — counts down to a target ISO date/time, updates DOM every second,
 * and toggles a "post-launch" state when the target has passed.
 *
 * Markup expected:
 *   <section data-sf-countdown data-target="2026-06-05T15:00:00" data-show-post-launch="true">
 *     ... [data-pre-launch] for the timer / pill / heading / pre-CTA
 *     ... [data-post-launch] for the post-launch replacement
 *     <span data-unit="days">    <span data-unit="hours">
 *     <span data-unit="minutes"> <span data-unit="seconds">
 *   </section>
 */
(function () {
  'use strict';

  function pad(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : String(n);
  }

  function init(el) {
    if (!el || el.dataset.sfCountdownInit === '1') return;
    el.dataset.sfCountdownInit = '1';

    var raw = el.getAttribute('data-target');
    if (!raw) return;
    var target = new Date(raw);
    if (isNaN(target.getTime())) return;

    // Measure pill-trace path length so the draw/erase animation
    // covers exactly one full lap around the pill.
    var tracePath = el.querySelector('.sf-countdown-banner__pill-trace-path');
    if (tracePath && typeof tracePath.getTotalLength === 'function') {
      try {
        var len = tracePath.getTotalLength();
        tracePath.style.setProperty('--sf-pill-trace-len', len);
      } catch (e) {
        /* SVG may not be in DOM yet; the CSS fallback (400) will be used */
      }
    }

    var daysEl = el.querySelector('[data-unit="days"]');
    var hoursEl = el.querySelector('[data-unit="hours"]');
    var minutesEl = el.querySelector('[data-unit="minutes"]');
    var secondsEl = el.querySelector('[data-unit="seconds"]');
    var postEls = el.querySelectorAll('[data-post-launch]');
    var showPost = el.getAttribute('data-show-post-launch') === 'true';

    function tick() {
      var now = Date.now();
      var diff = target.getTime() - now;

      if (diff <= 0) {
        // Launched
        el.setAttribute('data-launched', 'true');
        // Show zeros briefly so it's never "----", then swap
        if (daysEl)    daysEl.textContent    = '00';
        if (hoursEl)   hoursEl.textContent   = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';

        if (showPost) {
          postEls.forEach(function (node) { node.hidden = false; });
        } else {
          el.style.display = 'none';
        }
        clearInterval(handle);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl)    daysEl.textContent    = pad(days);
      if (hoursEl)   hoursEl.textContent   = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    var handle = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-sf-countdown]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Re-init on Shopify theme editor reload events
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector && e.target.querySelector('[data-sf-countdown]');
      if (root) init(root);
    });
  }
})();
